'use strict';

/**
 * Adjustement of anchors navigation based on sticky header
 */
function japanAnchorsNavigation() {
    $('.js-special-page-anchor-link').click(function (e) {
        var $anchorLink = $(this),
            $anchorTarget = $($anchorLink.attr('href')),
            scrollTopValue = $anchorTarget.length ? $anchorTarget.offset().top : '0',
            isDesktop = window.vbqUtils.breakpoint.is('fromDesktop');

        e.preventDefault();

        if (isDesktop && window.vbqUtils.cache.$header.length) {
            scrollTopValue -= window.vbqUtils.cache.$header.height();
        }

        if ($anchorTarget.length) {
            window.vbqUtils.cache.$html.animate({
                scrollTop: scrollTopValue - 30
            }, 1000);
        }
    });
}

/**
 * Newsletter custom locale events
 * @param {jQuery} $form - jquery form element
 */
function newsletterLocaleEvents($form) {
    var $newsletterWrapper = $form.closest('#js-newsletter-wrapper'),
        $emailField = $form.find('#js-landingNewsletterEmail'),
        source = $emailField && $emailField.length ? $emailField.attr('data-source') : '';

    $form.on('change', '.js-newsletter-locales', function () {
        var $select = $(this),
            $selectedOption = $select.find('option:selected'),
            selectedLocaleId = $selectedOption && $selectedOption.length ? $selectedOption.val() : '';
        
        $.ajax({
            url: window.Urls.getCustomNewsletterLocale,
            data: {
                localeId: selectedLocaleId,
                source: source
            }
        })
        .done(function (response) {
            if (response) {
                $newsletterWrapper.html(response);
                $newsletterWrapper.find('.js-newsletter-title').text($newsletterWrapper.attr("data-title"));
                $newsletterWrapper.find('.js-landingNewsletterSubscriptionSuccess').text($newsletterWrapper.attr("data-success-msg"));

                // re-initialize the newsletter submit events
                japanNewsletter();
                window.vbqUtils.initFloatingLabels($newsletterWrapper.find('#js-landingNewsletterSubscription'));
            }
        });
    });
}

/**
 * Newsletter functionality
 */
function japanNewsletter() {
    // standard form validation (formPrepare.js, validationLogic.js, ...) can not be used here
    // so the form status and error message are managed directly through jQuery validator
    var $form = $('#js-landingNewsletterSubscription'),
        $formSubmit = $form.find('.js-special-newsletter-submit');

    if ($form.length) {
        var $formfieldset = $form.find('.gl_form-group'),
            $email = $form.find('#js-landingNewsletterEmail'),
            $errorMessage = $form.find('.gl_error-message'),
            validator = $form.validate(),
            options = {};

        $email.rules('add', {
            required: true,
            email: true
        });

        $email.on('keyup input', window.vbqUtils._debounce(function () {
            if ($(this).val() !== '') {
                validator.element(this);
            }
        }, 200));

        // put back the form in pristine state (input with no value, no error)
        validator.resetForm();
        $formfieldset.removeClass('gl_has-error');

        // run submit if submit button was clicked
        $formSubmit.on('click keydown', function (e) {
            // mouse click or enter/space key
            if (e.type == 'click' || (e.type == 'keydown' && (e.keyCode == 13 || e.keyCode == 32))) {
                // prevent the default action to stop scrolling when space is pressed
                e.preventDefault();

                $form.submit();
            }
        });

        //handle submit form logic for mistral2 newsletter form
        $form.on('submit', function (e) {
            e.preventDefault();

            if (!$form.valid()) {
                return false;
            }

            var email = $email.val(),
                source = $email.data('source'),
                optin = $form.find('.optin').prop('checked');

            //send email to server
            $.ajax({
                method: 'POST',
                url: window.Urls.subscribeToNewsletter,
                data: {
                    email: email,
                    source: source,
                    optinconsent: optin
                },
                cache: false,
                beforeSend: function () {
                    options = {};
                    $formfieldset.removeClass('gl_has-success gl_has-error').addClass('gl_loading');
                }
            }).done(function (data) {
                // GDPR-33 - GDPR - Revision of consents
                if (!data.error && data.type == 'success') {
                    $formfieldset.removeClass('gl_loading').addClass('gl_has-success');
                    $form.addClass('hidden');
                    $('.js-landingNewsletterSubscriptionSuccess').removeClass('hidden');
                }
                // GDPR-26 - GDPR - Mistral2 Modal - New consent modal
                else if (!data.error && data.type == 'consents') {
                    window.vbqUtils.dialog.open({
                        url: window.Urls.getConsentForm,
                        customFocusOnCloseElement: $formSubmit,
                        options: {
                            width: 'auto',
                            dialogClass : 'consent-dialog',
                            open: function () {
                                window.vbqUtils.initializeJQueryUiPlugins();

                                var $consentForm = $('#js-newsletterSubscriptionConsents'),
                                    $newsletterSubscriptionConsentsButton = $('#js-newsletterSubscriptionConsentsButton');

                                $newsletterSubscriptionConsentsButton.click(function () {
                                    $newsletterSubscriptionConsentsButton.attr('disabled', 'disabled');
                                    window.vbqUtils.progress.show($newsletterSubscriptionConsentsButton);

                                    $.ajax({
                                        method: 'POST',
                                        url: window.Urls.consentForNewsletterSubscription,
                                        data: {
                                            email: email,
                                            source: source,
                                            optinconsent: $consentForm.find('#dwfrm_profile_customer_optinconsent').prop('checked')
                                        },
                                        cache: false,
                                        beforeSend: function () {
                                            options = {};
                                            $formfieldset.removeClass('gl_has-success gl_has-error').addClass('gl_loading');
                                        }
                                    }).done(function (data) {
                                        $formfieldset.removeClass('gl_loading');

                                        if (!data.alert && data.type == 'success') {
                                            $formfieldset.addClass('gl_has-success');
                                            $form.addClass('hidden');
                                            $('.js-landingNewsletterSubscriptionSuccess').removeClass('hidden');
                                        }
                                        else {
                                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                                            validator.showErrors(options);
                                        }

                                        window.vbqUtils.dialog.close();
                                    }).fail(function () {
                                        $formfieldset.removeClass('gl_loading');
                                        options[$email.attr('name')] = window.Resources.SERVER_ERROR;
                                        validator.showErrors(options);
                                        window.vbqUtils.dialog.close();
                                    });
                                });
                            }.bind(this)
                        },
                        closeCallback: function () {
                            // reset the form
                            $formfieldset.removeClass('gl_has-success gl_loading');
                        }
                    });
                }
                else {
                    $formfieldset.removeClass('gl_loading');
                    switch (data.type) {
                        case 'format':
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL;
                            break;
                        case 'already':
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_ALREADY;
                            break;
                        default:
                            options[$email.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                            break;
                    }
                    validator.showErrors(options);
                }
            }).fail(function () {
                $formfieldset.removeClass('gl_loading');
                options[$email.attr('name')] = window.Resources.SERVER_ERROR;
                validator.showErrors(options);
            });
        });

        newsletterLocaleEvents($form);
    }
}

/**
 * Maison carousel
 */
function japanCarousel1Init() {
    var $maisonCarousel = $('.js-carousel-maison');

    var setCarouselMaison = function () {
        if ($maisonCarousel.length) {
            if ($maisonCarousel.hasClass('slick-initialized')) {
                $maisonCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                carouselConfig = {
                    slidesToShow: isMobile ? 1 : (isTablet ? 3 : 4),
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: true
                };

            $maisonCarousel.slick(carouselConfig).slick('setPosition');
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setCarouselMaison();
    }, 200));

    setCarouselMaison();
}

/**
 * Products carousel
 */
function japanCarousel2Init() {
    var $productsCarousel = $('.js-carousel-products');

    var setCarouselProducts = function () {
        if ($productsCarousel.length) {
            if ($productsCarousel.hasClass('slick-initialized')) {
                $productsCarousel.slick('unslick').removeClass('slick-initialized');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                isDesktop = window.vbqUtils.breakpoint.is('fromDesktop'),
                carouselConfig = {
                    slidesToShow: isMobile ? 1 : (isTablet ? 3 : (isDesktop ? 4 : 6)),
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: true
                };

            $productsCarousel.slick(carouselConfig).slick('setPosition');
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setCarouselProducts();
    }, 200));

    setCarouselProducts();
}

/**
 * Stores carousel
 */
function japanCarousel3Init() {
    var $storesCarousel = $('.js-carousel-stores');

    var setCarouselStores = function () {
        if ($storesCarousel.length) {
            if ($storesCarousel.hasClass('slick-initialized')) {
                $storesCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                carouselConfig = {
                    slidesToShow: isMobile ? 1 : (isTablet ? 3 : 4),
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: true
                };

            $storesCarousel.slick(carouselConfig).slick('setPosition');
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setCarouselStores();
    }, 200));

    setCarouselStores();
}

/**
 * Init carousel from second content
 * @param {jQuery} $content - content with carousel
 */
function initSecondCarousel($content) {
    if (!$content || $content.length == 0) {
        // do nothing if no content was provided
        return ;
    }

    var $carousel = $content.find('.js-part-carousel');

    if (!$carousel || $carousel.length == 0) {
        // do nothing if no carousel found
        return;
    }

    if ($carousel.hasClass('slick-initialized')) {
        // do nothing as the carousel is already initialized
        return;
    }

    $carousel.slick({
        slidesToShow: 1,
        arrows: true,
        dots: false
    });
}

/**
 * Second content events
 */
function japanSecondContentEvents() {
    var elementClasses = {
        contentTile: '.js-second-content-tile',
        contentWrapper: '.js-second-content-wrapper'
    };

    $(document).on('click', '.js-discover', function () {
        var $button = $(this),
            $secondContentTile = $button.siblings(elementClasses.contentTile),
            $secondContentWrapper = $button.closest('.js-carousel-section').find(elementClasses.contentWrapper);

        // remove any shown second content
        $(elementClasses.contentWrapper).html('');

        // show the new content
        $secondContentWrapper.html($secondContentTile.html());
        // init any second carousel found
        initSecondCarousel($secondContentWrapper);
    });

    $(document).on('click', '.js-close', function () {
        var $button = $(this),
            $secondContentWrapper = $button.closest(elementClasses.contentWrapper);

        // remove the content
        $secondContentWrapper.html('');
    });
}

window.addEventListener('mainJsLoaded', function () {
    japanAnchorsNavigation();
    japanNewsletter();
    japanCarousel1Init();
    japanCarousel2Init();
    japanCarousel3Init();
    japanSecondContentEvents();
});
